/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import {
    IColumn, ITableVisualizationStaticProperties, ITableVisualizationDynamicProperties, RowType
} from '../types/tableVisualizationTypes';
import { IVisitorContext } from '../types/tableVisualizationConverterTypes';
import { createEmptyDetailRow } from './rowFactory';

function fillContextWithEmptyDetailRow(_context: IVisitorContext, columns: IColumn[], rowHeight: number, index: number) {
    const context = _context;
    if (context.table) {
        context.table.rows.push(createEmptyDetailRow(columns, rowHeight, context.rowsCount + index));
    }
}

function createEmptyDetailRows(
    _context: IVisitorContext,
    staticProperties: ITableVisualizationStaticProperties,
    dynamicProperties: ITableVisualizationDynamicProperties
): IVisitorContext {
    const context = _context;

    for (let i = 0; i < dynamicProperties.rowsCountToRender - context.addedRowsCount; i += 1) {
        fillContextWithEmptyDetailRow(context, staticProperties.columns, dynamicProperties.minRowHeight, i);
    }

    return context;
}

export default {
    [RowType.DETAIL]: createEmptyDetailRows
};
